import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { COOKIES_VERSION, PRIVACY_VERSION } from './policies-version';
import { ToastService } from '@ildes/services/toast.service';

@Component({
  selector: 'app-policies',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    RouterModule
  ],
  template: `
<mat-toolbar>
  <div class="column-full-space">
    <img src="./assets/images/logo.png" class="logo">
  </div>
  <button (click)="back()" mat-icon-button aria-label="volver">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<div class="container">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [(selectedIndex)]="policyIdIndex" (selectedIndexChange)="onTabChange($event)">
        <mat-tab label="Política de privacidad"></mat-tab>
        <mat-tab label="Cookies y datos"></mat-tab>
    </mat-tab-group>
  <!-- <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="left-tabs">
    <a mat-tab-link [active]="policyId==='privacy'" (click)="policyId='privacy'"> Política de privacidad </a>
    <a mat-tab-link [active]="policyId==='cookies'" (click)="policyId='cookies'"> Cookies y datos </a>
  </nav> -->
  <div class="scrollable-content" [class.extra-padding-bottom]="openedCookies" *ngIf="policyIdIndex === 0">
  <h1>Política de Tratamiento de Datos Personales</h1>

    <h2>Objetivo</h2>
    <p>
        Dar a conocer a todos nuestros empleados, clientes, proveedores, accionistas y en general todos los agentes que interfieren en el desarrollo del negocio las políticas de tratamiento de datos y manejo de cookies, garantizando el derecho que tienen para conocer, actualizar y rectificar la información que se haya recogido sobre ellas y que repose en las Bases de Datos o archivos de ILDES S.A.S. (en adelante ILDES), en cumplimiento de los derechos, libertades y garantías constitucionales a que se refieren los artículos 15 y 20 de la Constitución Política de 1991 y las leyes 1581 de 2012, decreto reglamentario 1377 de 2013 y decreto 1074 de 2015.
    </p>

    <h2>1. Responsable del tratamiento</h2>
    <p><strong>Empresa:</strong> ILDES S.A.S.</p>
    <p><strong>Responsable:</strong> ILDES S.A.S. <strong>NIT:</strong> 901922446-6</p>
    <p><strong>Correo de contacto: </strong> <a href="mailto:contacto@ildes.co">contacto@ildes.co</a></p>

    <h2>2. Datos recolectados</h2>
    <p>ILDES podrá solicitar y tratar los siguientes datos personales:</p>
    <ul>
        <li><strong>Clientes y usuarios de la vía:</strong> nombre, correo electrónico, teléfonos, dirección, cédula.</li>
        <li><strong>Usuarios de la plataforma:</strong> nombre, género, correo, teléfono, dirección, cédula, fecha de nacimiento, grupo sanguíneo y demás datos necesarios para fines laborales y legales.</li>
        <li><strong>Datos de navegación:</strong> cookies y tecnologías similares (tratadas bajo la <a [routerLink]="['/policies/cookies']">Política de Cookies y Datos</a> publicada en este sitio).</li>
    </ul>

    <h2>3. Finalidad del tratamiento</h2>
    <p>Los datos serán tratados para los siguientes fines:</p>
    <ul>
        <li><strong>Empleados:</strong> gestión laboral, cumplimiento de obligaciones legales, seguridad social, control interno y contacto en casos de emergencia.</li>
        <li><strong>Clientes y usuarios:</strong>
            <ul>
                <li>Atender solicitudes y reportes de incidencias.</li>
                <li>Contactar con fines comerciales o informativos.</li>
                <li>Gestionar y dar solución a incidencias, conservando la trazabilidad del proceso.</li>
                <li>Una vez resuelta la incidencia, los datos de los clientes se ofuscarán de forma irreversible.</li>
            </ul>
        </li>
    </ul>

    <h2>4. Autorización del titular</h2>
    <p>
        ILDES solicitará a empleados, clientes y usuarios la autorización previa, expresa e informada para el tratamiento de sus datos personales. Esta autorización podrá otorgarse por medios físicos, electrónicos o digitales, y será almacenada como evidencia para efectos de verificación ante la autoridad de control.
    </p>

    <h2>5. Derechos de los titulares</h2>
    <p>De acuerdo con la Constitución y la Ley, los titulares de los datos personales podrán ejercer en cualquier momento los siguientes derechos:</p>
    <ul>
        <li>Conocer, actualizar y rectificar sus datos personales.</li>
        <li>Solicitar prueba de la autorización otorgada.</li>
        <li>Ser informados sobre el uso que se ha dado a sus datos.</li>
        <li>Presentar quejas ante la <strong>Superintendencia de Industria y Comercio (SIC)</strong> por infracciones a la normativa.</li>
        <li>Revocar la autorización y/o solicitar la supresión de sus datos, cuando no exista deber legal o contractual de conservarlos.</li>
    </ul>

    <h2>6. Procedimiento para ejercer derechos</h2>
    <p>Los titulares podrán ejercer sus derechos enviando una solicitud a:</p>
    <p><strong>Correo electrónico:</strong> <a href="mailto:contacto@ildes.co">contacto@ildes.co</a></p>
    <p>ILDES responderá dentro de los plazos establecidos por la Ley 1581 de 2012 y el Decreto 1377 de 2013.</p>

    <h2>7. Medidas de seguridad</h2>
    <p>
        ILDES implementa medidas administrativas, técnicas y físicas razonables para garantizar la seguridad de los datos personales y evitar su adulteración, pérdida, consulta, uso o acceso no autorizado.
    </p>

    <h2>8. No cesión de datos a terceros</h2>
    <p>
        ILDES no compartirá los datos personales con terceros, salvo cuando exista deber legal de hacerlo o autorización expresa del titular.
    </p>

    <h2>9. Vigencia de la política</h2>
    <p>
        La presente política entra en vigencia a partir del <strong>{{humanizedDatePrivacyPolicy}}</strong> y permanecerá vigente hasta tanto se modifique de forma expresa.
    </p>
  </div>
  <div class="scrollable-content" [class.extra-padding-bottom]="openedCookies" *ngIf="policyIdIndex === 1">
    <h1>Política de Cookies y Tecnologías Similares</h1>
    <p>
        <i>
            Última actualización: {{humanizedDateCookesUpdatedPolicy}}
        </i>
    </p>
    <p>
        En ildes.co utilizamos cookies y tecnologías similares para garantizar el correcto funcionamiento, mejorar la experiencia del usuario y, en algunos casos, realizar análisis.
        Esta política explica qué tecnologías usamos, con qué fines y cómo puedes gestionarlas, cumpliendo con la normativa europea (RGPD y ePrivacy) y la Ley colombiana 1581 de Protección de Datos Personales.
    </p>
    
<h2>1. Cookies y tecnologías similares</h2>
<ul>
  <li><strong>Cookies:</strong> Pequeños archivos que se almacenan en tu dispositivo al visitar nuestro sitio web.</li>
  <li><strong>Tecnologías similares:</strong> Almacenamiento local (localStorage, sessionStorage), IndexedDB, WebSQL y otros métodos que guardan información en tu dispositivo.</li>
  <li>Estas tecnologías pueden usarse para fines <strong>técnicos</strong>, <strong>analíticos</strong> o <strong>publicitarios</strong>, dependiendo de su tipo.</li>
</ul>

<h2>2. Tecnologías que usamos</h2>

<h3>2.1 Cookies estrictamente necesarias (siempre activas)</h3>
<ul>
  <li><strong>AMP_ba62b82db2 (Sentry):</strong> Monitorización y carga eficiente con AMP. Duración: sesión.</li>
  <li><strong>sentry-sc (Sentry):</strong> Detección de errores y estabilidad del sistema. Duración: [ej. 90 días].</li>
  <li><strong>Cookies de Google generadas automáticamente por reCAPTCHA:</strong>
    <ul>
      <li>__Secure-1PAPISID, __Secure-1PSID, __Secure-1PSIDCC, __Secure-1PSIDTS</li>
      <li>__Secure-3PAPISID, __Secure-3PSID, __Secure-3PSIDCC, __Secure-3PSIDTS</li>
      <li>__Secure-ENID, __Secure-YEC</li>
      <li>SID, SIDCC, HSID, SSID, DV, APISID, SAPISID, NID</li>
    </ul>
    Finalidad: Seguridad y autenticación, protección contra bots y fraude. Estas cookies son **estrictamente necesarias** para el funcionamiento de reCAPTCHA y no se pueden desactivar sin impedir su funcionamiento.
  </li>
</ul>

<h3>2.2 Cookies opcionales (requieren consentimiento explícito)</h3>
<ul>
  <li><strong>AMP_MKTG_ba62b82db2 (Sentry):</strong> Analítica y marketing técnico. Duración: [ej. 30 días].</li>
  <li><strong>Cookies de Google generadas por reCAPTCHA con fines de analítica/marketing:</strong>
    <ul>
      <li>_ga, _ga_J1K4E6HRL7: Analítica web y seguimiento de visitas.</li>
      <li>AEC, OTZ, SEARCH_SAMESITE: Publicidad y remarketing.</li>
    </ul>
    Estas cookies solo se activan si el usuario ha dado su consentimiento explícito.
  </li>
</ul>

<h3>2.3 Almacenamiento local (localStorage, IndexedDB)</h3>
<ul>
  <li>Guardamos datos necesarios para la sesión del usuario y cacheo de resultados de servicios para mejorar el rendimiento.</li>
  <li>Este almacenamiento <strong>puede incluir datos personales</strong> si es necesario para la funcionalidad solicitada por el usuario.</li>
  <li>No se utiliza para fines publicitarios sin consentimiento.</li>
</ul>

<h2>3. Base legal para el uso</h2>
<ul>
  <li><strong>Cookies y almacenamiento necesarios:</strong> Tratamiento basado en el interés legítimo para el funcionamiento seguro del servicio.</li>
  <li><strong>Cookies y almacenamiento opcionales:</strong> Solo se activan tras <strong>consentimiento explícito</strong> del usuario, cumpliendo RGPD y Ley 1581.</li>
</ul>

<h2>4. Gestión del consentimiento</h2>
<ul>
  <li>Puedes <strong>aceptar, rechazar o configurar</strong> las cookies y almacenamiento opcional mediante el <strong>panel de configuración</strong> (accesible desde el banner inicial o en el pie de página).</li>
  <li>El consentimiento se puede <strong>revocar en cualquier momento</strong> desde la misma sección.</li>
  <li>Opcional: almacenar la elección en <strong>localStorage o cookie propia</strong> para no mostrar repetidamente el banner.</li>
</ul>

<h2>5. Derechos del usuario (Ley 1581 y RGPD)</h2>
<ul>
  <li>Acceder a los datos personales.</li>
  <li>Rectificar información incorrecta o incompleta.</li>
  <li>Solicitar supresión de datos almacenados.</li>
  <li>Revocar el consentimiento para el tratamiento de datos no esenciales.</li>
  <li>Solicitar información sobre finalidades y terceros que reciben los datos.</li>
</ul>
<p>Para ejercer estos derechos, contacta a <strong>[correo o contacto de privacidad]</strong>.</p>

<h2>6. Conservación</h2>
<ul>
  <li>Cookies se mantienen según la duración indicada en cada caso.</li>
  <li>El almacenamiento local se mantiene hasta que se elimine manualmente o desde la configuración de la app.</li>
</ul>


    <h2>7. Más información</h2>
    <p>Consulta nuestra <a [routerLink]="['/policies/privacy']">Política de privacidad</a> para detalles completos sobre el tratamiento de tus datos personales y medidas de seguridad implementadas.</p>
  </div>
</div>
  
  `,
  styleUrls: ['./policies.component.css'],
})
export class PoliciesComponent implements OnInit{
    tabPanel;
    policyId = 'privacy';
    policyIdIndex = 0;
    sections = ['privacy', 'cookies'];

    get openedCookies() {
        return this.toast.getCookiesOpened();
    }
    get humanizedDateCookesUpdatedPolicy() {
        const d = new Date(COOKIES_VERSION);
        const months = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

        return `${d.getDate()} de ${months[d.getMonth()]} de ${d.getFullYear()}`;
    }

    get humanizedDatePrivacyPolicy() {
        const d = new Date(PRIVACY_VERSION);
        const months = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

        return `${d.getDate()} de ${months[d.getMonth()]} de ${d.getFullYear()}`;
    }

    constructor(
      private location: Location,
      private route: ActivatedRoute,
      private router: Router,
      private toast: ToastService,
    ) { }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.policyId = params.get('policy');
            this.policyIdIndex = this.sections.indexOf(this.policyId);    
        });
    }    
  
    back() {
      this.location.back();
    }

    onTabChange($event) {
        this.policyIdIndex = $event;
        this.policyId = this.sections[this.policyIdIndex];
        this.router.navigate(['/policies', this.policyId], { replaceUrl: true });
    }
}
